import { PLANNER_PERMISSIONS } from "@/constants/permission";
import { NavigationRoute } from "@/lib/permission";

import {
  SquareGanttChart,
  Terminal,
  Workflow,
  List,
} from "lucide-react";

export type SidebarMenuItemType = NavigationRoute & {
  icon?: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  children?: SidebarMenuItemType[];
};

export const MENU_ITEMS: SidebarMenuItemType[] = [
  {
    title: "Plant 1",
    url: "",
    icon: Workflow,
    children: [
      {
        title: "Planner",
        url: "/planner",
        icon: SquareGanttChart,
        permissions: [PLANNER_PERMISSIONS.PLANT1_VIEW_JOB], // WOR-1793 Req #1
      },
      {
        title: "AI Prompt Config",
        url: "/prompt-configuration",
        icon: Terminal,
      },
      {
        title: "Flow",
        url: "/flow",
        icon: Workflow,
      },
      {
        title: "Editable Columns",
        url: "/settings/editable-columns",
        permissions: [PLANNER_PERMISSIONS.PLANT3_EDITABLE_COLUMN], // WOR-1793 Req #13
      },
    ],
  },
  {
    title: "Plant 3",
    url: "/plant-3",
    icon: List,
    children: [
      {
        title: "Job Orders",
        url: "/list",
        // icon: SquareGanttChart,
        permissions: [PLANNER_PERMISSIONS.PLANT3_VIEW_JOB], // WOR-1793 Req #7
      },
      {
        title: "Job Process Schedule",
        url: "/job-scheduler",
        // icon: CalendarDays,
        permissions: [PLANNER_PERMISSIONS.PLANT3_VIEW_JOB], // WOR-1587 - Job Gantt Chart
      },
      {
        title: "Configuration",
        url: "",
        // icon: Settings,
        children: [
          {
            title: "Part - Process",
            url: "/processes-management",
            // icon: ListOrdered,
            permissions: [PLANNER_PERMISSIONS.PROCESS_MANAGEMENT], // WOR-1793 Req #14
          },
          {
            title: "Technicians",
            url: "/technicians",
            // icon: Users,
            permissions: [PLANNER_PERMISSIONS.TECHNICIAN_MANAGE], // WOR-1793 Req #15
          },
          {
            title: "Machines",
            url: "/machines",
            // icon: Cog,
            permissions: [PLANNER_PERMISSIONS.MACHINE_MANAGE], // WOR-1793 Req #16
          },
        ],
      },
    ],
  },
];
